/**
 * @desc 封装 cookie 方法
 * @time 2023-07-31 15:59:52
 * @user simxin
 */

import { reportLoginProcess } from '../report';
/**
 * @desc 获取 cookie
 */
export function getCookie(name: string) {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1, cookie.length);
    }
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
}

/**
 * @desc 设置 cookie
 */
export function setCookie(name: string, value: string, days?: number) {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/;domain=.trtc.io;`;
}

/**
 * @desc 清理 cookie
 */
export function clearCookie() {
  const protectedCookies = ['trtcDeployId', 'beautyDeployId'];
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
    if (!protectedCookies.includes(name)) {
      document.cookie = `${name}=;path=/;domain=.trtc.io;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
      document.cookie = `${name}=;path=/;domain=.tencentcloud.com;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
      document.cookie = `${name}=;path=/;domain=.cloud.tencent.com;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    }
  }
}
/**
 * 
 * @desc 删除 cookie
 */
export function deleteCookie(name: string) {
  document.cookie = `${name}=;path=/;domain=.trtc.io;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}

/**
 * @desc 获取 uin
 */
export function getUin() {
  return getCookie('saas_uin');
}

/**
 * @desc 获取 ownuin
 */
export function getOwnUin() {
  return getCookie('saas_ownerUin');
}

/**
 * @desc 获取 saasToken
 */
export function getSaasToken() {
  return getCookie('saas_token');
}

/**
 * @desc 获取 saasSid
 */
export function getSid() {
  return getCookie('saas_sid');
}

/**
 * @desc 获取 csrf code
 * 直调会用到，转发用不到
 */
export function getCsrfCode(skey: string) {
  const key = skey || getCookie('skey');
  if (!key) return '';
  let hash = 5381;
  for (let i = 0; i < key.length; i++) {
    hash += (hash << 5) + key.charCodeAt(i);
  }
  return hash & 0x7fffffff;
}

/**
 * @desc 获取转发 csrf code
 */
export function getProxyCsrfCode() {
  let hash = 5381;
  const saasToken: string = getCookie('saas_token') || '';
  for (let i = 0, len = saasToken.length; i < len; ++i) {
    hash += (hash << 5) + saasToken.charCodeAt(i);
  }
  return hash & 0x7fffffff;
}

/**
 * @desc 跳转登录
 */
export function gotoLogin() {
  reportLoginProcess('gotoLoginFunc');
  window.location.href =
    `//${window.AVPORTAL_HOST}/login` + `?fro=gt&s_url=${encodeURIComponent(window.location.href)}`;
}

/**
 * @desc 存储登录态
 */
export function saveLogin({
  saas_uin,
  saas_ownerUin,
  saas_token,
  saas_isOldDomain,
}: LoginCookies) {
  setCookie('saas_uin', saas_uin);
  setCookie('saas_ownerUin', saas_ownerUin);
  setCookie('saas_token', saas_token);
  saas_isOldDomain && setCookie('saas_isOldDomain', saas_isOldDomain);
}
